import { createContext } from 'react';

import { AuthenticationStore } from './interface';

export default createContext<AuthenticationStore>(null as any);
